// src/pages/Photography.js - NO theme-dependent overlays
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getAllSeries } from "../data/projects";

const Photography = () => {
  const [series, setSeries] = useState([]);
  const [loadedImages, setLoadedImages] = useState({});

  useEffect(() => {
    window.scrollTo(0, 0);
    setSeries(getAllSeries());
  }, []);

  const handleImageLoad = (seriesId) => {
    setLoadedImages((prev) => ({
      ...prev,
      [seriesId]: true,
    }));
  };

  return (
    <div className="min-h-screen">
      <div className="pt-24 md:pt-48 pb-24">
        <div className="container mx-auto px-6 md:px-12">
          <div className="max-w-[900px] mx-auto">
            <p className="text-center text-sm text-gray-300 mb-12">
              Oh and sometimes I like to take photos. Enjoy!
            </p>

            {/* Series Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8">
              {series.map((item) => (
                <Link
                  key={item.id}
                  to={`/photography/${item.id}`}
                  className="group relative overflow-hidden"
                >
                  <div className="aspect-w-4 aspect-h-3 relative">
                    {/* Loading state */}
                    {!loadedImages[item.id] && (
                      <div className="absolute inset-0 flex items-center justify-center bg-gray-900">
                        <div className="h-8 w-8 rounded-full border-t-2 border-b-2 border-gray-500 animate-spin"></div>
                      </div>
                    )}

                    {/* Cover Image */}
                    <img
                      src={item.coverImage}
                      alt={item.title}
                      className={`w-full h-full object-cover transition-all duration-500 group-hover:scale-105 ${
                        loadedImages[item.id] ? "opacity-100" : "opacity-0"
                      }`}
                      onLoad={() => handleImageLoad(item.id)}
                    />

                    {/* Dark overlay - HARDCODED to stay dark, NOT theme-dependent */}
                    <div
                      className="absolute inset-0 transition-all duration-300"
                      style={{
                        backgroundColor: "rgba(0, 0, 0, 0.2)",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.backgroundColor =
                          "rgba(0, 0, 0, 0.3)")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor =
                          "rgba(0, 0, 0, 0.2)")
                      }
                    />

                    {/* Centered Title */}
                    <div className="absolute inset-0 flex items-center justify-center">
                      <h2
                        className="text-2xl md:text-3xl font-display font-medium text-overlay-white"
                        style={{
                          textShadow: "0 1px 3px rgba(0, 0, 0, 0.5)",
                          letterSpacing: "0.05em",
                        }}
                      >
                        {item.title}
                      </h2>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Photography;
